<template>
  <!-- begin teams -->
  <div :class="`teams wrap blockOffsets grow parent row height_fill v-centered margin_vertical-small-phone ${className}`">

    <!-- begin team team_left -->
    <div
      :class="[
        'width_fill-phone  team team_left parent row v-centered height_fill grow margin_vertical-small-phone row_reverse-phone row_reverse-phone',
        namesBeneathLogo ? 'h-around' : 'h-end',
        leftTeamClass
    ]">
      <!-- begin teamName -->
      <div
        v-if="!namesBeneathLogo"
        :class="`child team__name text_right font-size_11 ${teamNameClass}`">
        {{ leftTeamName }}
      </div>
      <!-- end teamName -->

      <!-- begin teamLogo -->
      <div :class="`child team__logo parent column centered ${teamLogoContainerClass}`">
        <lazy-image
          :src="leftTeamLogo"
          :class-name="`team__logo_image margin_centered ${teamLogoClass} ${leftTeamLogoClass}`"
          relative/>
        <span
          v-if="namesBeneathLogo"
          :class="`team__name text_centered font-weight_semibold ${teamNameClass} ${leftTeamNameClass}`">
          {{ leftTeamName }}
        </span>
      </div>
      <!-- end teamLogo -->

      <!-- begin teamCountry -->
      <div
        :class="{
          'child team__country': true ,
          'order_first': namesBeneathLogo
      }">
        <lazy-image
          :src="leftTeamCountry"
          :class-name="`parent centered ${teamCountryClass} ${leftTeamCountry}`"
          circle
          relative/>

      </div>
      <!-- end teamLogo -->

      <!-- begin teamRatio -->
      <div :class="`child team__ratio ${ratioContainerClass} ${leftTeamRatioClass}`">
        <p
          :class="{
            'color_blue parent centered team__ratio_info margin-top_zero margin_centered font-weight_bold bordered bordered_blue' : true,
            'team__ratio_info-size-9' : isSmallRatio,
            [teamRatioClass]: teamRatioClass
        }">
          {{ leftTeamRatio | fixSum }}
        </p>
      </div>
      <!-- end teamRatio -->

    </div>
    <!-- end teamLeft -->

    <!-- begin versus -->
    <div
      :class="{'child versus text_centered font-weight_bold color_gray grow margin_centered-phone margin_vertical-small-phone' : true,
               'versus_size-18': isBigVersus,
               [versusClass]: versusClass

    }">
      VS
    </div>
    <!-- end versus -->

    <!-- begin team team_right -->
    <div
      :class="[
        'width_fill-phone team team_right parent row v-centered height_fill grow margin_vertical-small-phone',
        namesBeneathLogo ? 'h-around' : null,
        rightTeamClass
    ]">

      <!-- begin teamRatio -->
      <div :class="`child team__ratio ${ratioContainerClass} ${rightTeamRatioClass}`">
        <p
          :class="{'margin-top_zero color_blue parent centered margin_centered team__ratio_info  font-weight_bold bordered bordered_blue' : true,
                   'team__ratio_info-size-9' : isSmallRatio,
                   [teamRatioClass]: teamRatioClass
        }">
          {{ rightTeamRatio | fixSum }}
        </p>
      </div>
      <!-- end teamRatio -->

      <!-- begin teamCountry -->
      <div
        :class="{
          'child team__country': true ,
          'order_last': namesBeneathLogo
      }">
        <lazy-image
          :src="rightTeamCountry"
          :class-name="`parent centered ${teamCountryClass} ${rightTeamCountryClass}`"
          circle
          relative/>

      </div>
      <!-- end teamCountry -->

      <!-- begin teamLogo -->
      <div
        :class="`child team__logo parent column centered ${teamLogoContainerClass}`">
        <lazy-image
          :src="rightTeamLogo"
          :class-name="`team__logo_image margin_centered ${teamLogoClass} ${leftTeamLogoClass}`"
          relative/>
        <span
          v-if="namesBeneathLogo"
          :class="`team__name text_centered font-weight_semibold ${teamNameClass}`">
          {{ rightTeamName }}
        </span>
      </div>
      <!-- end teamLogo -->

      <!-- begin teamName -->
      <div
        v-if="!namesBeneathLogo"
        :class="`child team__name text_left font-size_11 ${teamNameClass}`">
        {{ rightTeamName }}
      </div>
      <!-- end teamName -->
    </div>
    <!-- end team team_right -->

    <!-- begin watchMatch -->
    <div
      v-if="withOpenMatchButton"
      class="child  watchMatch parent centered margin_vertical-small-phone margin_centered-phone">
      <base-button
        :label="`Открыть просмотр матча ${leftTeamName} против ${rightTeamName}.`"
        class-name="parent centered bordered_darkBlue bordered grow_phone margin_base-phone watchMatch__button color_darkBlue"
        unstyled>
        <svg
          class="fa-icon"
          height="1em"
          role="presentation"
          version="1.1"
          viewBox="0 0 1792 1792"
          width="1em">
          <path d="M711 1128l484-250-484-253v503zM896 266q168 0 324.5 4.5t229.5 9.5l73 4q1 0 17 1.5t23 3 23.5 4.5 28.5 8 28 13 31 19.5 29 26.5q6 6 15.5 18.5t29 58.5 26.5 101q8 64 12.5 136.5t5.5 113.5v40 136q1 145-18 290-7 55-25 99.5t-32 61.5l-14 17q-14 15-29 26.5t-31 19-28 12.5-28.5 8-24 4.5-23 3-16.5 1.5q-251 19-627 19-207-2-359.5-6.5t-200.5-7.5l-49-4-36-4q-36-5-54.5-10t-51-21-56.5-41q-6-6-15.5-18.5t-29-58.5-26.5-101q-8-64-12.5-136.5t-5.5-113.5v-40-136q-1-145 18-290 7-55 25-99.5t32-61.5l14-17q14-15 29-26.5t31-19.5 28-13 28.5-8 23.5-4.5 23-3 17-1.5q251-18 627-18z"/>
        </svg>
      </base-button>
    </div>
    <!-- end watchMatch -->

  </div>
  <!-- end teams -->
</template>

<script>
export default {
  name: "MatchTeams",
  props: {
    className: {
      type: String,
      required: false,
      default: ""
    },
    modifier: {
      type: String,
      required: false,
      default: ""
    },
    namesBeneathLogo: {
      type: Boolean,
      required: false,
      default: false
    },
    isBigVersus: {
      type: Boolean,
      required: false,
      default: false
    },
    isSmallRatio: {
      type: Boolean,
      required: false,
      default: false
    },
    withOpenMatchButton: {
      type: Boolean,
      required: false,
      default: false
    },
    teamLogoClass: {
      type: String,
      required: false,
      default: ""
    },
    teamNameClass: {
      type: String,
      required: false,
      default: ""
    },
    rightTeamClass: {
      type: String,
      required: false,
      default: ""
    },
    teamLogoContainerClass: {
      type: String,
      required: false,
      default: ""
    },
    rightTeamCountryClass: {
      type: String,
      required: false,
      default: ""
    },
    rightTeamLogoClass: {
      type: String,
      required: false,
      default: ""
    },
    rightTeamRatioClass: {
      type: String,
      required: false,
      default: ""
    },
    leftTeamClass: {
      type: String,
      required: false,
      default: ""
    },
    leftTeamCountryClass: {
      type: String,
      required: false,
      default: ""
    },
    leftTeamLogoClass: {
      type: String,
      required: false,
      default: ""
    },
    teamRatioClass: {
      type: String,
      required: false,
      default: ""
    },
    leftTeamRatioClass: {
      type: String,
      required: false,
      default: ""
    },
    leftTeamNameClass: {
      type: String,
      required: false,
      default: ""
    },
    ratioContainerClass: {
      type: String,
      required: false,
      default: ""
    },
    versusClass: {
      type: String,
      required: false,
      default: ""
    },
    teamCountryClass: {
      type: String,
      required: false,
      default: ""
    },
    leftTeamName: {
      type: String,
      required: true
    },
    leftTeamLogo: {
      type: String,
      required: true
    },
    leftTeamCountry: {
      type: String,
      required: true
    },
    leftTeamRatio: {
      type: [Number, String],
      required: true
    },
    rightTeamName: {
      type: String,
      required: true
    },
    rightTeamLogo: {
      type: [Number, String],
      required: true
    },
    rightTeamRatio: {
      type: [Number, String],
      required: true
    },
    rightTeamCountry: {
      type: String,
      required: true
    },
    matchUrl: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="sass" scoped>
@import '../assets/sass/conf/_colors.sass'
@import '../assets/sass/conf/_sizes.sass'
@import '../assets/sass/conf/_breakpoints.sass'
@import '../assets/sass/conf/_easing.sass'

.teams
  @include breakpoint($betsTabletLess)
    margin-top: .5em
    margin-bottom: 1.5em
.tableContentRow
  &:hover
    .team__ratio_info
      background-color: $blue $i
      color: $white

.child
	flex: 1 0 auto
.team
	@include breakpoint($phone-less)
		justify-content: space-around
 	// Контейнер
	&__logo
		min-width: em(40, 12)
		max-width: em(65, 12)

		// Изображение
		&_image
	    	max-width: em(30, 12)

	&__name
		min-width: em(90, 11)
		max-width: em(90, 11)
		@include breakpoint($phone-less)
			text-align:  left

	// Контейнер
	&__ratio
		max-width: em(50, 12)

		// Соотношение
		&_info
      max-width: em(32, 12)
      padding: .5em 0.15em .5em 0
      &-size-9
        font-size: em(9, 12)

	&__country
		max-width: em(27.5, 12)

		.imageContainer
			max-width: em(27.5, 12)
			min-height: em(27.5, 12)

.watchMatch
	@include breakpoint($tablet-less)
    	max-width: em(270, 12)

	&__button
    opacity: .3
    font-size: em(16, 12)
    will-change: opacity, color
    transition-property: color, opacity
    transition-timing-function: $sharp

    &:active, &:focus, &:hover
      color: $blue
      opacity: 1

    @include breakpoint($tablet)
        padding: .25em
        border-width: 1px $i

    @include breakpoint($desktop)
        border-width: 0 $i

    @include breakpoint($tablet-less)
        padding: .25em
        border-width: 1px $i
        max-width: em(100)
.versus
  max-width: em(29, 12)
  color: #989ba4
  &_size-18
    font-size: em(18, 12)
</style>



// WEBPACK FOOTER //
// src/components/MatchTeams.vue